module.exports = __webpack_public_path__ + "assets/images/voice-feature@2x-e08a93a4fd6b1c6a0e77edc47c189066.png";